<script>
import { TabItemsDirective, TabItemDirective } from "@syncfusion/ej2-vue-navigations/src/tab/items.directive";
import { defineAsyncComponent } from "@common/defineAsyncComponent";
// import { TabItemsDirective, TabItemDirective } from "@syncfusion/ej2-vue-navigations";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { actionStore } from "@common/actionStore";

let datasetPaneConfig = {
    cId: "datasetPane",
    cType: "datasetPane",
    cTitle: "Dataset Pane",
    showInCmpList: false,
    cTemplate: `<div v-if="datasetId" class="dataset-pane-container" :id="cId + '_wrapper'">
                    <div v-if="details">
                        <div class="settings-header">
                             <h1 class="settings-title">Saved grid name: {{details.cTitle}}</h1>
                        </div>
                        <div class="dataset-settings-container">
                            <div class="dataset-settings">
                                <ejs-tab id="tab_default">
                                    <div class="e-tab-header">
                                        <div>Details</div>
                                        <div>Statistics</div>
                                        <div>Test</div>
                                    </div>
                                    <div class="e-content">
                                        <div>
                                            <h2>Fields</h2>
                                            <br>
                                            <div class="col-md-12 col-sm-12">
                                                <grid cId="grid_datasetpane_fields_info" :prop-data="details.columns"></grid>
                                            </div>
                                            <br>
                                            <h2>Settings</h2>
                                            <br>
                                            <div class="col-md-12 col-sm-12">
                                                <grid cId="grid_settings" :prop-data="settings"></grid>
                                            </div>
                                        </div>
                                        <div>
                                            <h2>Statistics</h2>
                                            <div class="col-md-12 col-sm-12 filter">
                                                <div class="col-md-5 col-sm-12">
                                                    <condensed-filter
                                                        :prop-filter-options="filterOptions"
                                                        :prop-filter-items="statistic"
                                                        cId="condensedFilter__statistic"
                                                        :prop-result="filteredItems"
                                                        @update:prop-result="filteredItems = $event"
                                                        :prop-filtering="filtering"
                                                        @update:prop-filtering="filtering = $event"
                                                        :prop-item-label="'records'"
                                                    ></condensed-filter>
                                                </div>
                                                <div class="clearfix"></div>
                                            </div>
                                            <!--<div class="col-md-12 col-sm-12">
                                                <chart cId="chart_statistic" :prop-title="chartTitle" :prop-data="chartStatistic" :prop-ignore-dataset="true"></chart>
                                            </div>-->
                                            <div class="col-md-12 col-sm-12">
                                                <grid cId="grid_statistics" :prop-data="filteredItems"></grid>
                                            </div>
                                        </div>
                                        <div id="runTestRequestData">
                                            <h2>Test</h2>
                                            <div style="text-align: center; margin-top: 100px">
                                                <control name="RUN_TEST_REQUEST"></control>
                                            </div>
                                            <div v-if="!testRequestReloading">
                                                <grid cId="grid_datasetTestRequestData" :prop-data="request"></grid>
                                            </div>
                                        </div>
                                    </div>
                                </ejs-tab>
                                <div class="button-area">
                                    <control name="EDIT_DATASET" :disabled="details.locked"></control>
                                    <control name="DELETE_DATASET" :disabled="details.locked"></control>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`,
    controls: [
        {
            name: 'RUN_TEST_REQUEST',
            type: "button",
            label: "Run Test Request on local instance",
            onclick: "runTestRequest"
        },
        {
            name: 'EDIT_DATASET',
            type: 'button',
            label: 'Edit',
            onclick: 'editDataset',
            cssClass: 'e-info'
        },
        {
            name: 'DELETE_DATASET',
            type: 'button',
            label: 'Delete',
            onclick: 'deleteDataset',
            cssClass: 'e-danger'
        },
    ]
};

const datasetPaneCmp = {
    name: 'datasetPane',
    props: {
        datasetId: {
            default: false
        }
    },
    data() {
        return {
            chartTitle: '',
            chartStatistic: {},
            filteredItems: {},
            filterOptions: {
                last_load: {
                    label: 'Last Used',
                },
                instance: {
                    label: 'Instance',
                },
                projectName: {
                    label: 'Project Name',
                },
                accountId: {
                    label: 'Account ID',
                },
                recruiterId: {
                    label: 'Recruiter ID',
                }
            },
            statistic: {},
            details: {},
            request: {},
            settings: {},
            filtering: false,
            testRequestReloading: false
        };
    },
    components: {
        chart: defineAsyncComponent(() => import('@common/chart/chart.vue')),
        grid: defineAsyncComponent(() => import('@common/grid/grid.vue')),
        "ejs-tab": defineAsyncComponent(() => import('@common/syncfusion/tab')),
        "e-tabitems": TabItemsDirective,
        "e-tabitem": TabItemDirective
    },
    methods: {
        async onLoad() {
            this.onPropsUpdate(false);
        },
        onUpdate() {
            // this.updateStatistic();
        },
        async onPropsUpdate() {
            await this.loadDetails();
            await this.initStatistic();
            this.initPropsForChart();
        },
        async initStatistic() {
            if (typeof this.datasetId !== 'string') return;
            let datasetId = this.datasetId.split('___')[2];
            if (!datasetId) return;
            this.sDs.post("sds_getDatasetStatistics", datasetId).then((response) => {
                if (response.status === 'success') {
                    this.statistic = response.data;
                    this.updateStatistic();
                }
            });
        },
        updateStatistic() {
            let statistic = [];
            let filteredStatistics = this.filteredItems;
            if (filteredStatistics) {
                for (let i in filteredStatistics) {
                    if (i === 'length') continue;
                    statistic.push({
                        date: filteredStatistics[i].date,
                        count: filteredStatistics[i].date_loads
                    });
                }
            }
            this.chartStatistic = statistic;
        },
        async loadDetails() {
            let interval = setInterval(async () => {
                if (!this.datasetId) return;
                clearInterval(interval);
                let response = await this.sDs.post("sds_getDatasetInfo", this.datasetId);
                if (response.status === 'success') {
                    let data = response.data;
                    for (let i in data.columns) {
                        if (i === 'length') continue;
                        if (data.columns[i]["sortDir"] === "0") {
                            data.columns[i]["sortDir"] = "desc";
                        } else if (data.columns[i]["sortDir"] === "1") {
                            data.columns[i]["sortDir"] = "asc";
                        }
                        if (data.columns[i].cTitle.indexOf('#MODIF1') !== -1) {
                            data.columns[i].cTitle = data.columns[i].cTitle.replace('#MODIF1', '_Datestamp');
                        }
                    }
                    let datasetSettings = [
                        { 'Name': 'Records Per Page', 'Value': data.pageSize },
                        { 'Name': 'Enable Column Search', 'Value': data.isColSearchApply },
                        { 'Name': 'Current Selected Folder', 'Value': data.folderTitle },
                        { 'Name': 'Enable Current Selected Filter', 'Value': data.isFilterApply },
                        { 'Name': 'Current Selected Filter', 'Value': data.filterTitle }
                    ];
                    this.settings = datasetSettings;
                    this.details = data;
                }
            }, 500);
        },
        runTestRequest() {
            library.showLoadingIndicator('runTestRequestData', 5); // NOSONAR
            this.testRequestReloading = true;
            let addParams = {
                useCaCode: 1
            };
            if (this.details.gridMode !== 'Detail') addParams.colValSummary = "all";
            this.sDs.post("sds_getDataset", this.datasetId, false, false, 0, addParams).then((response) => {
                if (response.status === 'success') {
                    let datasetRequest = [];
                    if (response.data && response.data.records) {
                        let obj = response.data.records;
                        Object.keys(obj).forEach(function (key) {
                            datasetRequest[datasetRequest.length] = obj[key];
                        });
                    }
                    let tmpRequest = {
                        records: datasetRequest
                    };
                    if (response.data.summary) {
                        tmpRequest['summary'] = response.data.summary;
                    }
                    this.request = tmpRequest;
                } else {
                    if (response && response.error) {
                        library.showToast(response.error.join('<br/>'), { timeout: 10, type: 'warning' });
                    } else {
                        library.showToast('Unable to retrieve data', { timeout: 10, type: 'warning' });
                    }
                }
                this.testRequestReloading = false;
                library.hideLoadingIndicator('runTestRequestData');
            });
        },
        async onMappedDataUpdate(property) {
            if (property === 'datasetId') {
                this.request = [];
                await this.loadDetails();
                await this.initStatistic();
            }
        },
        initPropsForChart() {
            let cTitle = this.details && this.details.cTitle ? this.details.cTitle : '';
            this.chartTitle = 'Number of requests per date for ' + cTitle + ' dataset';
        },
        editDataset: async function () {
            let dsId = this.datasetId;
            let self = this;
            library.showLoadingIndicator(this.cId + '_wrapper');
            this.sDs.post("sds_propogateDatasetFromGlobalToLocal", dsId).then(async () => {
                library.hideLoadingIndicator(this.cId + '_wrapper');
                let instance = await configStore.getDevDashLocalInstanceDetails();
                let tmpUrl = instance.url + '/coordinator/index.php?editLocalDataset&datasetID=' + encodeURIComponent(dsId) + (instance.sId ? '&copyPHPSESSID=' + instance.sId : '');
                let tmpWindow = window.open(tmpUrl, 'editedDatasetArea', 'scrollbars=yes,resizable=yes,width=1000,height=1000,status=yes,top=100,left=100');
                let tmpInterval = setInterval(() => {
                    if (tmpWindow && tmpWindow.closed) {
                        clearInterval(tmpInterval);
                        if (actionStore) {
                            actionStore.executeGlobalMethod('datasetList', 'initDataset', [], self.parentStoreId);
                        }
                    }
                }, 500); // NOSONAR
            });
        },
        deleteDataset: async function () {
            let dsId = this.datasetId;
            let self = this;
            library.showDialog('Are you sure you want to remove dataset completely? This action can not be undone.',
                function () {
                    this.sDs.post("sds_deleteDataset", dsId).then((/* response */) => {
                        if (actionStore) {
                            actionStore.executeGlobalMethod('datasetList', 'initDataset', [], self.parentStoreId);
                        }
                    });
                },
                false,
                {
                    'title': 'Confirm to Continue'
                });
        },
    }
};

componentStore.initComponent(datasetPaneCmp, datasetPaneConfig);
export { datasetPaneConfig, datasetPaneCmp };
export default datasetPaneCmp;
</script>

<style>
    .dataset-pane-container table {
        text-align: left;
    }
    .dataset-pane-container table td, .dataset-pane-container table th {
        padding:3px 6px;
        border-bottom: 1px solid #dedede;
    }
    .dataset-pane-container .e-content {
        font-size:10px;
        margin: 20px;
    }
    .dataset-pane-container .settings-header {
        position: relative;
        height: 50px;
        font-weight: 400 !important;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgb(25, 118, 210);
        color: #ffffff;
    }

    .dataset-pane-container .settings-title {
        font-size: 18px;
    }

    .dataset-pane-container .dataset-settings-container {
        background-color: #ddd;
        padding: 5px;
        flex: 1 1 auto;
        display: flex;
        font-size: 16px;
    }

    .dataset-pane-container .dataset-settings {
        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
        padding: 20px;
        background-color: #fff;
        flex: 1 1 auto;
    }

    .dataset-pane-container .button-area {
        width: 50%;
        margin-left:49%;
    }

    .dataset-pane-container .button-area .e-control {
        flex-grow: 1;
        margin-left: 20px;
    }
</style>
